import { render, staticRenderFns } from "./ProcesoCompraEventoSga.vue?vue&type=template&id=560eb793"
import script from "./ProcesoCompraEventoSga.vue?vue&type=script&lang=js"
export * from "./ProcesoCompraEventoSga.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports